import Axios from 'axios';
import { toastr } from 'react-redux-toastr';
import { createAction } from 'redux-act';
import { url } from 'utils/url';
import { log, errorMsg } from 'utils';

export const SCHEDULING_FETCH_DATA_INIT = createAction(
  'SCHEDULING_FETCH_DATA_INIT'
);
export const SCHEDULING_FETCH_DATA_SUCCESS = createAction(
  'SCHEDULING_FETCH_DATA_SUCCESS'
);
export const SCHEDULING_FETCH_DATA_FAIL = createAction(
  'SCHEDULING_FETCH_DATA_FAIL'
);

export const SCHEDULING_DELETE_SCHEDULING_INIT = createAction(
  'SCHEDULING_DELETE_SCHEDULING_INIT'
);
export const SCHEDULING_DELETE_SCHEDULING_SUCCESS = createAction(
  'SCHEDULING_DELETE_SCHEDULING_SUCCESS'
);
export const SCHEDULING_DELETE_SCHEDULING_FAIL = createAction(
  'SCHEDULING_DELETE_SCHEDULING_FAIL'
);

export const SCHEDULING_CLEAR_DATA = createAction(
  'SCHEDULING_CLEAR_DATA'
);

export const SCHEDULING_CREATE_SCHEDULING_INIT = createAction(
  'SCHEDULING_CREATE_SCHEDULING_INIT'
);
export const SCHEDULING_CREATE_SCHEDULING_SUCCESS = createAction(
  'SCHEDULING_CREATE_SCHEDULING_SUCCESS'
);
export const SCHEDULING_CREATE_SCHEDULING_FAIL = createAction(
  'SCHEDULING_CREATE_SCHEDULING_FAIL'
);

export const SCHEDULING_MODIFY_SCHEDULING_INIT = createAction(
  'SCHEDULING_MODIFY_SCHEDULING_INIT'
);
export const SCHEDULING_MODIFY_SCHEDULING_SUCCESS = createAction(
  'SCHEDULING_MODIFY_SCHEDULING_SUCCESS'
);
export const SCHEDULING_MODIFY_SCHEDULING_FAIL = createAction(
  'SCHEDULING_MODIFY_SCHEDULING_FAIL'
);

export const SCHEDULING_CLEAN_UP = createAction(
  'SCHEDULING_CLEAN_UP'
);

export const SCHEDULING_CLEAR_DATA_LOGOUT = createAction(
  'SCHEDULING_CLEAR_DATA_LOGOUT'
);

export const SET_MEDIA_SCHEDULING = createAction('SET_MEDIA_SCHEDULING');

export const fetchScheduling = ({ schedulingId, siteId }) => {
  // eslint-disable-next-line
  return async (dispatch, getState) => {
    dispatch(SCHEDULING_FETCH_DATA_INIT());
    if (schedulingId) {
      let schedulingData;
      try {

        schedulingData = await Axios.get(`${url}/scheduling`, {
          params: {
            siteId,
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        });
      } catch (error) {
        toastr.error('', `${errorMsg(dispatch, error)}`);
        return dispatch(SCHEDULING_FETCH_DATA_FAIL({ error }));
      }
      const scheduling = { ...schedulingData, id: schedulingId };
      return dispatch(
        SCHEDULING_FETCH_DATA_SUCCESS({
          list: getState().scheduling.list,
          scheduling,
        })
      );
    }

    if (siteId) {
      let categories;
      try {

        categories = await Axios.get(`${url}/scheduling`, {
          params: {
            siteId,
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        });
      } catch (error) {
        toastr.error('', `${errorMsg(dispatch, error)}`);
        return dispatch(SCHEDULING_FETCH_DATA_FAIL({ error }));
      }
      categories = categories.data.data.filter(
        (scheduling) => scheduling.siteId === siteId
      );
      return dispatch(
        SCHEDULING_FETCH_DATA_SUCCESS({
          list: categories,
          scheduling: getState().scheduling.scheduling,
        })
      );
    }
  };
};

export const deleteScheduling = ({ id, siteId }, cb) => {
  return async (dispatch) => {
    dispatch(SCHEDULING_DELETE_SCHEDULING_INIT());

    try {

      await Axios.delete(`${url}/scheduling/delete`, {
        params: {
          id,
          siteId,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
    } catch (error) {
      let errorMessage;
      if (error.response) {
        errorMessage = error && error.response && error.response.data.message;
      }
      toastr.error('', errorMessage);
      return dispatch(
        SCHEDULING_DELETE_SCHEDULING_FAIL({
          error: errorMessage,
        })
      );
    }

    toastr.success('', 'The scheduling was deleted.');
    cb();
    return dispatch(SCHEDULING_DELETE_SCHEDULING_SUCCESS({ id }));
  };
};

export const clearCategoriesData = () => {
  return (dispatch) => {
    dispatch(SCHEDULING_CLEAR_DATA());
  };
};

export const clearCategoriesDataLogout = () => {
  return (dispatch) => {
    dispatch(SCHEDULING_CLEAR_DATA_LOGOUT());
  };
};

export const createScheduling = (
  {  name, description, type, days, start, end, dates, siteId},
  setIsModalCategoryShow
) => {
  return async (dispatch) => {
    dispatch(SCHEDULING_CREATE_SCHEDULING_INIT());
    let createCategory;
    const scheduling = {
      name,
      description,
      type,
      start,
      end,
      days: JSON.stringify(days),
      dates: JSON.stringify(dates),
      siteId,
    };

    try {

      createCategory = await Axios.post(`${url}/scheduling/create`, scheduling, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
      log(createCategory, '<<< created scheduling');
    } catch (error) {
      log(error.response, '<<< ERROR CREATE MEDIA SCHEDULING');
      let errorMessage;
      if (error.response) {
        errorMessage = error && error.response && error.response.data.message;
      }
      toastr.error('', errorMessage);
      return dispatch(
        SCHEDULING_CREATE_SCHEDULING_FAIL({
          error: error && error.response && error.response.data,
        })
      );
    }

    toastr.success('', 'Category created successfully');
    setIsModalCategoryShow(false);
    dispatch(fetchScheduling({ siteId }))
    return dispatch(
      SCHEDULING_CREATE_SCHEDULING_SUCCESS({
        scheduling: createCategory.data.data,
      })
    );
  };
};

export const modifyScheduling = (
  { id, name, description, siteId, type, start, end, days, dates },
  setIsModalCategoryShow
) => {
  return async (dispatch) => {
    dispatch(SCHEDULING_MODIFY_SCHEDULING_INIT());

    const schedulingData = {
      id,
      name,
      start,
      end,
      description,
      siteId,
      type,
      days: JSON.stringify(days),
      dates: JSON.stringify(dates),
    };

    try {
      await Axios.post(`${url}/scheduling/edit`, schedulingData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
    } catch (error) {
      let errorMessage;
      if (error.response) {
        errorMessage = error && error.response && error.response.data.message;
      }
      toastr.error('', errorMessage);
      return dispatch(
        SCHEDULING_MODIFY_SCHEDULING_FAIL({
          error: error && error.response && error.response.data,
        })
      );
    }

    toastr.success('', 'Category updated successfully');
    setIsModalCategoryShow(false);

    dispatch(fetchScheduling({ siteId }))
    return dispatch(
      SCHEDULING_MODIFY_SCHEDULING_SUCCESS({
        mediaCategory: schedulingData,
        id,
      })
    );
  };
};

export const categoriesCleanUp = () => (dispatch) =>
  dispatch(SCHEDULING_CLEAN_UP());

// added by me
export const setScheduling = (data) => {
  return (dispatch) => {
    dispatch(
      SET_MEDIA_SCHEDULING({
        data,
      })
    );
    // cb();
  };
};
